function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.84375,3.375 L17.15625,3.375 C17.6222403,3.375 18,3.75275974 18,4.21875 C18,4.68474026 17.6222403,5.0625 17.15625,5.0625 L0.84375,5.0625 C0.377759742,5.0625 5.70673477e-17,4.68474026 0,4.21875 C-5.70673477e-17,3.75275974 0.377759742,3.375 0.84375,3.375 Z M0.84375,8.15625 L17.15625,8.15625 C17.6222403,8.15625 18,8.53400974 18,9 C18,9.46599026 17.6222403,9.84375 17.15625,9.84375 L0.84375,9.84375 C0.377759742,9.84375 5.70673477e-17,9.46599026 0,9 C-5.70673477e-17,8.53400974 0.377759742,8.15625 0.84375,8.15625 Z M0.84375,12.9375 L17.15625,12.9375 C17.6222403,12.9375 18,13.3152597 18,13.78125 C18,14.2472403 17.6222403,14.625 17.15625,14.625 L0.84375,14.625 C0.377759742,14.625 5.70673477e-17,14.2472403 0,13.78125 C-5.70673477e-17,13.3152597 0.377759742,12.9375 0.84375,12.9375 Z",
  id: "menu-icon",
  transform: "translate(0,-3)"
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    width: "1.285714285714286rem",
    height: "0.8571428571428571rem",
    fill: "fillColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.7cdd7f50.svg";
export { ForwardRef as ReactComponent };